import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { Col, Row } from "react-bootstrap";

import Navbar from "views/Navbar";
import Footer from "views/Footer";
import SEO from "components/SEO";
import LanguageSelector from "components/LanguageSelector";

import "utils/fixFontAwesome";
import breakDownAllNodes from "utils/breakDownAllNodes";

import PageSection from "components/PageSection";
import SectionHeader from "components/SectionHeader";

import "../style/main.scss";

/**
 * get file name list from content/sections folder
 */
export const query = graphql`
  query PageQuery($langKey: String!, $slug: String!) {
    site {
      siteMetadata {
        keywords
        description
      }
    }
    allMarkdownRemark(
      filter: { fields: { langKey: { eq: $langKey } } }
      sort: { order: ASC, fields: [fields___directoryName, fields___fileName] }
    ) {
      nodes {
        frontmatter {
          brand
          anchor
          content
          copyright
          header
          subheader
          imageFileName
          jumpToAnchor
          jumpToAnchorText
          menuText
          privacyHref
          privacyText
          termsHref
          termsText
          title
          social {
            facebook
            github
            linkedin
            medium
            twitter
            instagram
            youtube
          }
        }
        fields {
          fileName
          directoryName
        }
      }
    }

    content: markdownRemark(frontmatter: {slug: {eq: $slug}}, fields: {langKey: {eq: $langKey}}) {
      html
      frontmatter {
        slug
        header
        subheader
      }
    }
  }
`;

const Page = ({ data, pathContext: { langKey, defaultLang, langTextMap } }) => {
  const {
    site: {
      siteMetadata: { keywords, description },
    },
    allMarkdownRemark: { nodes },
    content: {
      html,
      frontmatter: {
        slug,
        header,
        subheader
      }
    }
  } = data;
  const { navBarNode, anchors, footerNode } = breakDownAllNodes(nodes);

  let langSelectorPart;
  if (langTextMap != null && Object.keys(langTextMap).length > 1) {
    langSelectorPart = (
      <LanguageSelector langKey={langKey} defaultLang={defaultLang} langTextMap={langTextMap} slug={slug} />
    );
  }

  return (
    <>
      <SEO lang={langKey} title="Top" keywords={keywords} description={description} />
      <Navbar
        anchors={anchors}
        frontmatter={navBarNode.frontmatter}
        extraItems={langSelectorPart}
        langKey={langKey}
        defaultLang={defaultLang}
      />

      <PageSection>
        <Row>
          <SectionHeader header={header} subheader={subheader} />
        </Row>
        <Row>
          <Col lg={12}>
            <div dangerouslySetInnerHTML={{__html: html}} />
          </Col>
        </Row>
      </PageSection>

      <Footer frontmatter={footerNode.frontmatter} />
    </>
  );
};

Page.propTypes = {
  data: PropTypes.object.isRequired,
  pathContext: PropTypes.object,
};

Page.defaultProps = {
  pathContext: {
    langKey: "en",
    defaultLang: "en",
    langTextMap: {},
  },
};

export default Page;
